import { Box, Button, Modal, Skeleton, Stack, Typography } from "@mui/material";
import { useUnit } from "effector-react";
import { useEffect, useState } from "react";

import { $playerData, $updatedPrevious } from "../store";
import { getTimeAway } from "../utils/getTimeAway";

export default function SessionModal() {
  const [updatedPrevious, playerData] = useUnit([
    $updatedPrevious,
    $playerData,
  ]);

  const isMobile = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const [open, setOpen] = useState(false);
  const [timeAway, setTimeAway] = useState({ minutes: 0, hours: 0 });

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("hasSeenModal");
    if (!hasSeenModal) {
      setOpen(true);
      sessionStorage.setItem("hasSeenModal", "true");
    }
  }, []);

  useEffect(() => {
    const timeAway = getTimeAway(updatedPrevious);
    setTimeAway(timeAway);
  }, [updatedPrevious]);

  const handleClose = () => {
    setOpen(false);
  };

  if (
    playerData.tutorial_step !== -2 ||
    isMobile() === false ||
    updatedPrevious === 0
  )
    return null;

  return (
    updatedPrevious && (
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            p: 2,
            top: "50%",
            width: "90dvw",
            left: "50%",
            boxShadow: 24,
            borderRadius: 4,
            border: "3px solid",
            position: "absolute",
            bgcolor: "background.paper",
            transform: "translate(-50%, -50%)",
            borderColor: "primary.borderSideBar",
            background: "linear-gradient( to top, #89a8dc, #7FA0DC)",
          }}
        >
          <Typography
            sx={{
              textShadow: `
                               -1.7px -1.7px 2px #344871,
                                1.7px -1.7px 2px #344871,
                                -1.7px 1.7px 2px #344871,
                                1.7px 1.7px 2px #344871
                              `,
            }}
            color="white"
            textAlign={"center"}
          >
            WELCOME BACK
          </Typography>
          <Typography
            color="white"
            fontSize={"12px"}
            textAlign={"center"}
            my={1}
          >
            Your valley has been hard at work!
          </Typography>
          <Stack
            padding={1}
            gap={"5px"}
            width={"100%"}
            borderRadius={"11px"}
            bgcolor="primary.light"
            boxShadow={"0px 4px 4px rgba(0, 0, 0, 0.15)"}
          >
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography color="white">Time Away :</Typography>
              {updatedPrevious ? (
                <Typography color="white" noWrap>
                  {timeAway.hours === 2
                    ? "More than 2 hours"
                    : `${timeAway.hours} hours, ${timeAway.minutes} minutes`}
                </Typography>
              ) : (
                <Skeleton
                  variant="text"
                  sx={{ height: "40px", width: "80px" }}
                />
              )}
            </Stack>

            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography color="white">Max Idle Time :</Typography>
              <Typography color="white">2 hours</Typography>
            </Stack>
          </Stack>
          <Button
            sx={{ width: "100%", mt: 2 }}
            variant="blue"
            onClick={handleClose}
          >
            Tap OK to continue
          </Button>
        </Box>
      </Modal>
    )
  );
}
